import { CustomColumn } from '../../../types/customColumn';
import { SaleSummary } from '../../../types/sale';
import { formatCurrency } from '../../../utils/formatCurrency';
import { getDteStatusPresentation } from '../dte/dteStatusPresentation';

export const saleHistoryColumns: CustomColumn<SaleSummary>[] = [
  {
    Header: 'Estado',
    accessor: 'status',
    customCell: ({ value }) => (
      <span className="text-sm font-medium text-black dark:text-white">
        {value === 'DRAFT_CANCELLED'
          ? 'Borrador descartado'
          : value === 'DTE_PENDING'
            ? 'En contingencia'
            : String(value).replaceAll('_', ' ')}
      </span>
    ),
  },
  {
    Header: 'Estado DTE',
    accessor: 'dteStatus',
    customCell: ({ value }) => {
      const presentation = getDteStatusPresentation(value);
      return (
        <span className={`inline-flex max-w-[260px] rounded-full border px-3 py-1 text-xs font-semibold ${presentation.className}`}>
          {presentation.label}
        </span>
      );
    },
  },
  /**
   * 📄 Tipo de documento
   */
  {
    Header: 'Documento',
    accessor: 'documentType',
    customCell: ({ row }) => (
      <div className="min-w-[180px]">
        <div className="font-medium text-black dark:text-white">
          {row.original.documentType || '—'}
        </div>

        <div className="text-xs text-gray-500 dark:text-gray-400">
          {row.original.documentNumber || 'Sin número'}
        </div>
      </div>
    ),
  },

  /**
   * 👤 Cliente
   */
  {
    Header: 'Cliente',
    accessor: 'customerName',
    customCell: ({ value }) => (
      <div className="min-w-[220px] max-w-[280px]">
        <p
          className="
            whitespace-normal
            break-words
            font-medium
            leading-6
            text-black
            dark:text-white
          "
        >
          {value || 'Cliente general'}
        </p>
      </div>
    ),
  },

  /**
   * 🏢 Sucursal
   */
  {
    Header: 'Sucursal',
    accessor: 'branchName',
    customCell: ({ value }) => (
      <span className="text-sm text-gray-700 dark:text-gray-300">
        {value || 'Sin sucursal'}
      </span>
    ),
  },

  /**
   * 📅 Fecha
   */
  {
    Header: 'Fecha',
    accessor: 'saleDate',
    customCell: ({ value }) => (
      <span className="whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
        {value || '—'}
      </span>
    ),
  },

  /**
   * 💰 Total venta
   */
  {
    Header: 'Total',
    accessor: 'total',
    showStatus: true,
    customCell: ({ value }) => (
      <div className="min-w-[140px]">
        <span className="font-bold text-primary">
          ${formatCurrency(value || 0)}
        </span>
      </div>
    ),
  },
];
